import { render } from "./lab_index.vue?vue&type=template&id=432f5657&scoped=true"
import script from "./lab_index.vue?vue&type=script&lang=js"
export * from "./lab_index.vue?vue&type=script&lang=js"

import "./lab_index.vue?vue&type=style&index=0&id=432f5657&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432f5657"]])

export default __exports__